import { useState } from 'react'

import type { Ticket } from '@/api/dto/ticket'
import Shared from '@/shared'
import type { Dispatch, SetStateAction } from 'react'

interface useViewModelProps {
  ticket: Ticket
}

interface ViewModel {
  texts: object
  states: {
    isRoadViewOpen: boolean
    isPurchase: boolean
    isDetailMapOpen: boolean
    ticket: Ticket
  }
  setters: {
    setIsRoadViewOpen: Dispatch<SetStateAction<boolean>>
    setIsDetailMapOpen: Dispatch<SetStateAction<boolean>>
    setTicket: Dispatch<SetStateAction<Ticket>>
  }
  handlers: object
}

const useTicketDetailViewModel = ({ ticket: initTicket }: useViewModelProps): ViewModel => {
  const [ticket, setTicket] = useState<Ticket>(initTicket)

  const [isRoadViewOpen, setIsRoadViewOpen] = useState(false)

  const { isPurchase } = Shared.States.useIsPurchase()
  const [isDetailMapOpen, setIsDetailMapOpen] = useState(false)

  return {
    texts: {},
    states: {
      isRoadViewOpen,
      isPurchase,
      isDetailMapOpen,
      ticket
    },
    setters: {
      setIsRoadViewOpen,
      setIsDetailMapOpen,
      setTicket
    },
    handlers: {}
  }
}

export default useTicketDetailViewModel
